'use strict';

customerZone.factory('AuthenticationInterceptor', ['$injector', '$log', function ($injector, $log) {
    // We have to inject by hand here to avoid circular dependencies

    var UWA_AUTH_KEY = '__uwa_auth';
    var ongoingRefreshRequest;

    var requiresBearerAuth = function(response){
        if (response.status !== 401) return false;
        var authHeader = response.headers('WWW-Authenticate');
        if (!authHeader) return false;
        return authHeader.split(' ')[0] === 'Bearer';
    };

    var AuthenticationInterceptor = {
        request: function(req) {
            req.headers = req.headers || {};
            if (isAuthenticatableRequest(req) && userIsAuthenticated())
                return authenticate(req);
            else
                return req;
        },
        responseError: function(response) {
            if (requiresBearerAuth(response) && response.config[UWA_AUTH_KEY]){
                $log.debug('Got a 401.  Will try to refresh token');
                return refreshToken()
                    .then(function() {
                        $log.debug('Token received.  Repeating request.');
                        // repeat the request without any authorization headers that might've been there.
                        var request = response.config;
                        delete request.headers['Authorization'];
                        var $http = $injector.get('$http');
                        return $http(request);
                    }, function(e){
                        $log.debug('Token could not be refreshed.', e);
                        forceUserLogin();
                        throw {data: 'going_to_login', headers: function(){}, 'status': -401, config: response.config};
                    });
            }
            else {
                throw response;
            }
        }
    };

    var isAuthenticatableRequest = function(request){
        return isApiRequest(request, 'unleashedApi') || isApiRequest(request, 'budskapApi');
    };

    var isApiRequest = function(request, api){
        var config = $injector.get('config');
        if (!config[api]) return false;
        if (!config[api]['endpoint']) return false;
        var unversionedUrl = request.url.replace(/\/\d{8}\//, '/'); // ignore versions in api urls
        return unversionedUrl.indexOf(config[api]['endpoint']) === 0;
    };

    var authenticate = function(request){
        if (request.headers['Authorization']) return request;
        var Session = $injector.get('Session');
        $log.debug('Adding authorization to request: '+request.method+' '+request.url);
        request.headers['Authorization'] = 'Bearer '+Session.token;
        request[UWA_AUTH_KEY] = 'added';
        return request;
    };

    var userIsAuthenticated = function(request){
        var Session = $injector.get('Session');
        return Session.authenticated();
    };

    var refreshToken = function() {
        if (!ongoingRefreshRequest) {
            var AuthenticationService = $injector.get('AuthenticationService');
            ongoingRefreshRequest = AuthenticationService.refresh()
                .then(function(){
                    ongoingRefreshRequest = undefined;
                });
        }
        return ongoingRefreshRequest;
    };

    var forceUserLogin = function(){
        var utils = $injector.get('utils');
        var Session = $injector.get('Session');
        if (!Session.authenticated()) return;
        $log.debug('Going to login');
        Session.destroy();
        utils.goToLogin();
    };

    return AuthenticationInterceptor;
}]);
